export class GatewaySessionNotReadyError extends Error {
  constructor(message = 'Gateway session is not ready') {
    super(message);
    this.name = 'GatewaySessionNotReadyError';
  }
}

export const isGatewaySessionNotReadyError = (
  error: unknown
): error is GatewaySessionNotReadyError => error instanceof GatewaySessionNotReadyError;
